// extracted by mini-css-extract-plugin
export default {"commentNote":"commentNote__3Zu9r","commentWarning":"commentWarning__2O80m"};